// --- les fonctionnalités de la page de paiement évènement

document.addEventListener('DOMContentLoaded', () => {

    // Page paiement Stripe
    let stripeContainer = document.getElementById('eventStripeContainer');
    if (stripeContainer){
        console.log("init checkout");
        initCheckout('eventStripeContainer');
    }

    let stripeReturnContainer = document.getElementById('eventStripeReturnContainer');
    if (stripeReturnContainer){
        console.log("init checkout retrun");
        processCheckoutReturn('eventStripeReturnContainer');
    }

});